module.exports = __webpack_public_path__ + "img/bandera_mexico.07121223.svg";